export default "__VITE_ASSET__Db98KBxo__"